// A shop's own product prices, as shoppers saw them in the shop's currency (Storefront transcripts,
// and the live store reads an outside agent shows through External MCP). This is shop catalogue
// data, like a table in an artifact, not what Poneva costs: usage shows only as credits (D74), and
// the UI money guard in test/ exempts this one file for that reason.
import { formatMoney, formatNumber } from '../artifacts/money';

/**
 * A shop price in the app's money style. A price the shop gave without its currency shows as a
 * number, never as a currency it may not be; a code the browser does not know still shows the amount.
 */
export function shopPrice(value: number, currency: string | undefined, locale: string): string {
  const precision = Number.isInteger(value) ? 0 : 2;
  if (!currency)
    return formatNumber(value, locale, {
      minimumFractionDigits: precision,
      maximumFractionDigits: precision,
    });
  try {
    return formatMoney(value, locale, currency, { full: true, precision });
  } catch {
    return `${formatNumber(value, locale, { minimumFractionDigits: precision, maximumFractionDigits: precision })} ${currency ?? ''}`.trim();
  }
}
